import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FlexBox, colors } from '@cimpress/react-components';
import { css } from '@emotion/react';
import { useState } from 'react';
export var DetailFieldVariant;
(function (DetailFieldVariant) {
    DetailFieldVariant["Info"] = "info";
    DetailFieldVariant["Danger"] = "danger";
})(DetailFieldVariant || (DetailFieldVariant = {}));
const displayFieldName = css `
    font-weight: 700;
    fint-size: 11px;
    margin-top: 5px;
    margin-bottom: 12px;
    text-transform: uppercase;
    color: ${colors.shale};
`;
const hiddenToggle = css `
    margin-top: 5px;
    margin-bottom: 9px;
    margin-left: 10px;
`;
const muted = css `
    font-style: italic;
    color: ${colors.alloy}
`;
const displayFieldValue = css `
    margin-top: 5px;
`;
const cssBlockInfo = css `
    border-left: 2px solid ${colors.info.base};
    padding-left: 5px;
`;
const cssBlockDanger = css `
    border-left: 2px solid ${colors.danger.base};
    padding-left: 5px;
`;
const getBlockStyle = (variant) => {
    switch (variant) {
        case DetailFieldVariant.Danger:
            return cssBlockDanger;
        case DetailFieldVariant.Info:
            return cssBlockInfo;
        default:
            return cssBlockInfo;
    }
};
export const DetailsField = ({ label, value, rawValue, withToggle, variant }) => {
    const [hidden, setHidden] = useState(withToggle);
    if (value === undefined && rawValue === undefined) {
        return _jsx("div", { children: "Error!" });
    }
    return _jsxs("div", Object.assign({ css: rawValue ? { marginBottom: '10px' } : getBlockStyle(variant) }, { children: [_jsx("div", { children: _jsxs(FlexBox, { children: [_jsx("div", Object.assign({ css: displayFieldName }, { children: label })), _jsx("div", Object.assign({ css: hiddenToggle }, { children: withToggle
                                ? _jsx("a", Object.assign({ role: 'button', onClick: () => setHidden(!hidden) }, { children: hidden ? 'show' : 'hide' }))
                                : null }))] }) }), !value && (!rawValue || (Array.isArray(rawValue) && rawValue.length === 0))
                ? _jsx("div", Object.assign({ css: muted }, { children: "None" }))
                : null, hidden
                ? null
                : rawValue
                    ? rawValue
                    : _jsx("div", Object.assign({ css: displayFieldValue }, { children: value }))] }));
};
